import React from 'react';
import './AboutVision.css';
import { motion } from 'framer-motion';

const AboutVision = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="about-vision" id="about">
      <div className="vision-container">
        <div className="vision-header">
          <motion.div 
            className="vision-label"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            ABOUT US
          </motion.div>
          <motion.h2 
            className="vision-title-main"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            OUR BRAND VISION
          </motion.h2>
        </div>
        
        <div className="vision-content-wrapper">
          {/* Background Large Letter */}
          <div className="bg-letter">K</div>

        <div className="vision-main">
          {/* Left Tilted Image */}
          <motion.div 
            className="vision-img-box left"
            initial={{ opacity: 0, x: isMobile ? 0 : -100, rotate: isMobile ? 0 : -5 }}
            whileInView={{ opacity: 1, x: 0, rotate: isMobile ? 0 : -5 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <div className="grid-bg green"></div>
            <img src="https://blacksalt.ascentbw.com/Images/Category/Strip2.webp" alt="Fashion Left" />
          </motion.div>

          {/* Center Content */}
          <div className="vision-content">
            <motion.h2 
              className="vision-title"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              BE WHO <br /> YOU ARE!
            </motion.h2>
            <motion.div 
              className="vision-divider"
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
            ></motion.div>
            <motion.p 
              className="vision-text"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              Refresh your style with on-trend pieces <br />
              from our clothing collection.
            </motion.p>
            <motion.button 
              className="start-shopping-btn"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.8 }}
              whileHover={{ scale: 1.05 }}
            >
              <span className="btn-text">START SHOPPING</span>
              <span className="btn-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline></svg>
              </span>
            </motion.button>
          </div>

          {/* Right Tilted Image */}
          <motion.div 
            className="vision-img-box right"
            initial={{ opacity: 0, x: isMobile ? 0 : 100, rotate: isMobile ? 0 : 5 }}
            whileInView={{ opacity: 1, x: 0, rotate: isMobile ? 0 : 5 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <div className="grid-bg purple"></div>
            <img src="https://images.unsplash.com/photo-1490367532201-b9bc1dc483f6?auto=format&fit=crop&q=80&w=600" alt="Fashion Right" />
            <div className="pin-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            </div>
          </motion.div>
        </div>

        {/* Bottom Banner Text */}
        <div className="vision-bottom-text">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 1, duration: 1 }}
          >
            FASHION IS PART OF THE DAILY AIR AND IT CHANGES ALL THE TIME, YOU CAN EVEN SEE THE APPROACHING OF A REVOLUTION IN CLOTHES —
          </motion.p>
        </div>
        </div>
      </div>
    </section>
  );
};

export default AboutVision;
